/**
 * 菜单逻辑权限
 */
import type { RouterType, ModuleType } from '@/types/router'
import store from '@/store'
import router, { resetRouter } from '@/router'
import { setSessionItem, getSessionItem } from '@/utils/sessionstorage'
import { getLocalItem } from '@/utils/localStorage'
import { userFirstPage } from '@/utils'

// 保存当前路由页面按钮权限
const permissionsRouter: any = {}

// 根据权限判断当前用户可进去的页面
export const jurisdictionRouter = (routerArr: ModuleType[]) => {
  // 所有菜单信息
  const allMenuData: any = {}
  // 导航栏模块菜单信息
  const navMenuData: ModuleType[] = []

  // 路由菜单信息
  const routerMenuList: any[] = []

  routerArr.forEach((routeritem) => {
    let routerList = []
    let moduleKey = ''
    let title = ''
    // 无需展示菜单页面
    if (Array.isArray(routeritem)) {
      routerList = routeritem
    } else {
      // 模块页面
      moduleKey = routeritem.moduleKey
      title = routeritem.title
      routerList = routeritem.router || []
    }

    // 判断是否有权限
    const modulePermission =
      store.getters['moduleCommon/getPermissionsObj'] &&
      store.getters['moduleCommon/getPermissionsObj'][title as string]

    // 模块下的二级菜单信息
    const sideMenuData: any[] = []
    if (userPermission(modulePermission)) {
      routerList.forEach((item: RouterType) => {
        item.moduleKey = moduleKey

        const analyList = analysisRouterItem(item, modulePermission)

        const authItem = { ...item }
        if (analyList.length > 0) {
          Object.assign(authItem, { children: analyList })
          if (!item.hide) {
            sideMenuData.push(authItem)
          }
          routerMenuList.push(authItem)
        }
      })
    }

    // 遍历完毕后判断当前模块是否存在信息
    if (!Array.isArray(routeritem) && sideMenuData.length > 0) {
      const { moduleKey, title, hide, icon } = routeritem
      allMenuData[moduleKey] = sideMenuData
      navMenuData.push({
        moduleKey,
        title: title,
        hide,
        icon,
        active: navMenuData.length === 0
      })
    }
  })
  // 所有权限菜单信息赋值
  store.commit('moduleCommon/ALL_MENU', allMenuData)
  store.commit('moduleCommon/NAV_MENU_ARR', navMenuData)
  // 设置初始页面为列表第一个数据 (未设置初始模块时)
  if (navMenuData.length > 0) {
    store.commit('moduleCommon/NAV_ACTIVED', navMenuData[0].moduleKey)
    getNavAndLeftMenuData({ moduleKey: navMenuData[0].moduleKey })
  }
  store.commit('moduleCommon/PERMISSIONS_ROUTER_OBJ', permissionsRouter)

  return { routerMenuList }
}

// 根据角色返回权限对比
const judgeRouter = (
  routerArr: any[],
  routerListPermission: any,
  parentRouter = '',
  moduleKey?: string,
  moduleAuthenticating?: boolean,
  mergeParentAuth?: boolean // 使用父级权限
) => {
  const curRouter: any[] = []
  if (Array.isArray(routerArr)) {
    routerArr.forEach((item) => {
      const { path, authenticating, meta, name, children, redirect } = item

      const key = `${parentRouter}/${path}`

      let routerPermissions = routerListPermission && routerListPermission[meta?.title]

      // 使用父级权限
      if (mergeParentAuth) {
        routerPermissions = routerListPermission
      }

      if (
        !(
          userPermission(routerPermissions || mergeParentAuth) ||
          authenticating ||
          moduleAuthenticating ||
          meta?.authenticating
        )
      ) {
        // 不存在权限返回
        return curRouter
      }

      // 三级菜单信息
      if (Array.isArray(children)) {
        const newData = judgeRouter(
          children,
          routerPermissions,
          key,
          moduleKey,
          moduleAuthenticating || authenticating,
          !children.some((childMenu) => childMenu.meta?.menuShow) // 下级菜单，存在需要校验权限的菜单则不适用父级展示权限
        )

        // 重定向子级页面
        for (let i = 0, len = children.length; i < len; i++) {
          const childPath = key + '/' + children[i].path // 三级菜单路径
          if (redirect === childPath && newData.some((nItem) => nItem.name !== children[i].name)) {
            children[i].path = redirect
            newData.unshift(children[i])
            // 获取页面 按钮权限
            const operaList =
              routerPermissions &&
              routerPermissions.items &&
              routerPermissions.items.map((operation: { permissionName: any }) => operation.permissionName)
            permissionsRouter[children[i].name as string] = operaList
            break
          }
        }

        if (item.meta) {
          item.meta.moduleKey = moduleKey
        }

        if (
          userPermission(routerPermissions || mergeParentAuth) ||
          ((moduleAuthenticating || authenticating || meta?.authenticating) && newData.length > 0)
        ) {
          item.path = key
          curRouter.push({ ...item, children: newData })
        }
      } else {
        // 判断是否 '【isOpen 】为审核通过' || '审核中并且设置了可访问时'
        if (
          userPermission(routerPermissions || mergeParentAuth) ||
          moduleAuthenticating ||
          authenticating ||
          meta?.authenticating
        ) {
          item.path = key
          if (item.meta) {
            item.meta.moduleKey = moduleKey
          }

          // 获取页面 按钮权限
          const operaList =
            routerPermissions &&
            routerPermissions.items &&
            routerPermissions.items.map((operation: { permissionName: any }) => operation.permissionName)
          permissionsRouter[name as string] = operaList

          curRouter.push(item)
        }
      }
    })
  }
  return curRouter
}

// 用户权限信息
const userPermission = (routerPermission: any) => {
  // 当前权限的开放 默认为 false
  const defaultPermission = false
  return !!(routerPermission || defaultPermission)
}

// 解析当前的路由信息
const analysisRouterItem = (routeritem: RouterType, modulePermission: any) => {
  const { children, path, moduleKey, authenticating, title } = routeritem
  // 判断是否有权限
  const routerListPermission = modulePermission && modulePermission[title as string]

  let judgeList = []
  // 根据角色返回权限对比,
  if ((userPermission(routerListPermission) || authenticating) && children) {
    judgeList = judgeRouter(children, routerListPermission, path, moduleKey, authenticating)
  }
  return judgeList
}

// 根据当前的模块key选择展示的左侧菜单
export const getNavAndLeftMenuData = (obj: { moduleKey: string; sideActiveName?: string; path?: string }) => {
  const { moduleKey, sideActiveName, path } = obj
  // 底部菜单模块不暂时数据
  if (path && path.indexOf('/footerWebs') !== -1) {
    store.commit('moduleCommon/SIDE_MENU_ARR', [])
    store.commit('moduleCommon/SIDE_ACTIVE', '')
    store.commit('moduleCommon/SIDE_STATUS', false)
  } else {
    // 可展示的数据形式
    const sideMenu = store.getters['moduleCommon/getAllMenu'][moduleKey]
    store.commit('moduleCommon/SIDE_MENU_ARR', sideMenu)
    if (sideActiveName) {
      store.commit('moduleCommon/SIDE_ACTIVE', sideActiveName)
    }
    store.commit('moduleCommon/SIDE_STATUS', true)
  }
}

/**
 * 验证当前菜单权限中是否存在某个页面
 * @param {*} menu Array 菜单数组
 * @param {*} activedMenu string 当前选中的页面信息
 */
const filterMenuName = (menu: any[], activedMenu: any) => {
  let hasPemssion = false
  try {
    if (Array.isArray(menu)) {
      menu.forEach((item) => {
        if (item.name === activedMenu) {
          hasPemssion = true
          throw Error()
        }
        if (item.children) {
          hasPemssion = filterMenuName(item.children, activedMenu)
          if (hasPemssion) {
            throw Error()
          }
        }
      })
    }
  } catch (e) {}

  return hasPemssion
}

/**
 * 通过菜单名称获取菜单的路径信息
 * @param {*} menuList Array // 菜单列表
 * @param {*} pageName string // 菜单名称
 */
export const getPageUrl = (menuList: any[], pageName: string) => {
  let resUrl = ''
  try {
    if (Array.isArray(menuList)) {
      menuList.forEach((menu) => {
        const title = menu?.title || menu.meta.title
        if (pageName === title) {
          resUrl = menu.redirect || menu.path
          throw Error()
        }
        if (menu.children) {
          resUrl = getPageUrl(menu.children, pageName)
          if (resUrl) {
            throw Error()
          }
        }
      })
    }
  } catch (e) {}
  return resUrl
}

// 重新获取登录者信息（获取最后一位登录者信息）
export const retrieveLoginInfo = () => {
  // 清除路由
  resetRouter()
  store.commit('moduleCommon/PREMISSION_ROUTER', null)

  // 获取最后一位登录者的 用户信息 & token & 最后登录时间
  const resetDataList = [
    {
      key: 'zl-user-info',
      commit: 'moduleCommon/USER_INFO'
    },
    {
      key: 'zl-nav-menu',
      commit: 'moduleCommon/ALL_MENU'
    },
    {
      key: 'zl-user-permission',
      commit: 'moduleCommon/PERMISSIONS_OBJ'
    }
  ]
  resetDataList.forEach((item) => {
    store.commit(item.commit, getLocalItem(item.key))
  })
  setSessionItem('zl-login-now-date', getLocalItem('zl-login-now-date'))

  // 判断当前用户和最后一位用户的菜单权限相同 则重新加载该页面
  const activedMenu = getSessionItem('zl-side-actived')
  let hasPemssion = false // 默认没有权限
  const allMenu = getSessionItem('zl-nav-menu')
  try {
    Object.keys(allMenu).forEach((menu) => {
      hasPemssion = filterMenuName(allMenu[menu], activedMenu)
      if (hasPemssion) {
        throw Error()
      }
    })
  } catch (e) {}

  if (hasPemssion) {
    // 存在同一权限页面，则再次刷新
    router.replace({
      path: '/redirect',
      query: {
        path: encodeURI(router.currentRoute.value.path)
      }
    })
  } else {
    router.push({
      path: userFirstPage('/login')
    })
  }
}
